module.exports = __webpack_public_path__ + "img/CSGO500.efd27775.svg";